/*!
  Pioneer WFRIA FlexgridItem v4.0.0-beta.53
  © 2023 Wells Fargo. All rights reserved.
*/
try {
  if (!window.__PIONEER_GLOBAL__) {
    window.__PIONEER_GLOBAL__ = {
      version: "4.0.0-beta.53",
      components: ["FlexgridItem"]
    };
  } else if (window.__PIONEER_GLOBAL__.components && window.__PIONEER_GLOBAL__.components.indexOf("FlexgridItem") < 0) {
    window.__PIONEER_GLOBAL__.components.push("FlexgridItem");
  }
} catch (error) {
  // catching server side rendering issues - windows is not defined there!
}

import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
const _excluded = ["children", "style", "span"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import PropTypes from "prop-types";
import React, { useContext } from "react";
import { breakpointsMap } from "../themes";
import { FlexgridContext } from "./FlexgridContext";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

function getBasis(span) {
  if (!span) {
    return {
      flexBasis: "auto"
    };
  }

  if (span === "auto") {
    return {
      flexBasis: "auto",
      flexGrow: 1,
      maxWidth: "100%"
    };
  }

  if (typeof span === "number") {
    const basis = `${span * 100 / 12}%`;
    return {
      flexBasis: `${basis}`,
      maxWidth: `${basis}`
    };
  }

  const basis = {};

  for (const size of Object.keys(span)) {
    if (breakpointsMap[size]) {
      basis[breakpointsMap[size]] = span[size] === "auto" ? {
        flexBasis: "auto",
        flexGrow: 1,
        maxWidth: "100%"
      } : {
        flexBasis: `${span[size] * 100 / 12}%`,
        maxWidth: `${span[size] * 100 / 12}%`
      };
    }
  }

  return basis;
}

function FlexgridItem(_ref) {
  let {
    children,
    style,
    span
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  const context = useContext(FlexgridContext);
  const flexBasis = getBasis(span);

  const cssRoot = _objectSpread(_objectSpread({
    boxSizing: "border-box"
  }, flexBasis), {}, {
    paddingLeft: context.columnGap,
    paddingTop: context.rowGap
  });

  return _jsx("div", _objectSpread(_objectSpread({
    css: cssRoot,
    style: style
  }, otherProps), {}, {
    children: children
  }));
}

FlexgridItem.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Children of the FlexgridItem. */
  children: PropTypes.node,

  /** The item will span across the provided number of grid tracks. */
  span: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.shape()])
} : {};
FlexgridItem.defaultProps = {
  children: null,
  span: null
};
export default FlexgridItem;